export default __webpack_public_path__ + "static/media/IPA.ccb5bf70.mp3";